import { gql } from '../../__generated__/gql'

export const TOGGLE_COMMUNITY_CONSOLIDATED_NOTIFICATION_READ_MUTATION = gql(`
  mutation toggleCommunityConsolidatedNotificationRead($notificationId: String!, $read: Boolean) {
    toggleCommunityConsolidatedNotificationRead(input: {notificationId: $notificationId, read: $read}) {
      clientMutationId
    }
  }
`)
